import React from 'react'
import styled from 'styled-components'
import { mobile } from '../responsive';

const Container = styled.div`
      
`
const Text = styled.div`
    height: 30%;
    background-color: #0039a6;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    font-weight: 500;
    text-align: center;
    margin-top: 2px;
    ${mobile({ width: "100%" })}
`;


const ItemAnnouncement = () => {
  return (
    <Container>
      <Text>
        Call our store at 248-693-5962 for further questions regarding
        equipment rentals and to create a reservation.
        <br/>
        &nbsp;
        <br/>
        Display photos may not accurately represent the exact models of the equipment
        available for rent. Call for further information on equipment models and details.
    </Text>
    </Container>
  )
}

export default ItemAnnouncement